import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import { Button } from '../../ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';
import { PopoverTrigger } from '../../ui/popover';

interface AppBarBadgeButtonProps {
  icon: ReactNode;
  count: number;
  ariaLabel: string;
  tooltip: string;
  moduleColor: string;
}

export const AppBarBadgeButton = forwardRef<HTMLButtonElement, AppBarBadgeButtonProps>(
  function AppBarBadgeButton({ icon, count, ariaLabel, tooltip, moduleColor }, ref) {
    const clampedCount = count > 99 ? '99+' : count;
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button
              ref={ref}
              variant="ghost"
              size="icon"
              className="relative hover:bg-accent"
              style={{ color: moduleColor }}
              aria-label={ariaLabel}
            >
              {icon}
              {count > 0 && (
                <span className="absolute -top-0.5 -right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-bold text-destructive-foreground">
                  {clampedCount}
                </span>
              )}
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    );
  },
);
